// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n * Makes the little calendar icon grey on Chrome\n * Otherwise it's not visible with dark mode styles\n */\n::-webkit-calendar-picker-indicator {\n  filter: invert(0.5);\n  position: relative;\n  top: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
